import { t } from 'i18next';
import React, { useMemo } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { ErrorMessage, Field, Formik, Form as FormikForm } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import RequiredAstric from '../../../components/DynamicForm/required-astric';
import { setTemplatesDetails } from '../../../redux/template/slice';
import { updateTemplateName } from '../../../redux/template';
import { commaSeparatedTemplateTypes } from './hook';
import { getTemplateValidationSchema } from './validation';


const TemplateNameModel = ({ show, close, fetch, type, title }) => {
	const { details } = useSelector(state => state.templates);
	const dispatch = useDispatch();
	const isEdit = useMemo(() => Boolean(details?.id), [details]);

	const handleClose = () => {
		close();
		dispatch(setTemplatesDetails(null));
	};

	const handleSubmit = async(values, { setSubmitting, resetForm }) => {
		try {
			const updateItem = {
				name: values.name,
				template_id: details.id
			};
			if (isEdit && details.id) {
				await dispatch(updateTemplateName(updateItem)).unwrap();
			}
			handleClose();
			resetForm();
			fetch();
		} catch (error) {
			toast.error(error.message);
			return error;
		} finally {
			setSubmitting(false);
		}
	};

	const getModelTitle = useMemo(() => {
		if (commaSeparatedTemplateTypes.includes(type) && !isEdit) {
			return t(`ALLOPATHY.MODEL.${type.toUpperCase()}`);
		}
		return t('GENERAL.NAME');
	}, [type, title, isEdit, t]);

	const getNameFieldLabel = useMemo(() => {
		if (commaSeparatedTemplateTypes.includes(type)) {
			const value = type.toUpperCase();
			return isEdit ? t(`ALLOPATHY.${type === 'timing' ? 'MODEL': 'NAV'}.${value}`) : t(`ALLOPATHY.MODEL.${value}`);
		} else {
			return t('GENERAL.NAME');
		}
	}, [type, isEdit, t]);

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered >
			<Modal.Header closeButton>
				<Modal.Title>{t(`GENERAL.${isEdit ? 'UPDATE' : 'ADD'}`)} {getModelTitle}</Modal.Title>
			</Modal.Header>

			<Formik
				initialValues={{
					name: details?.name || '',
				}}
				validationSchema={getTemplateValidationSchema({ t, type, name: getNameFieldLabel })}
				enableReinitialize={true}
				onSubmit={handleSubmit}
			>
				{({ isSubmitting }) => (
					<FormikForm>
						<Modal.Body>
							<Row className="mb-3">
								<Form.Group>
									<Form.Label>{getNameFieldLabel} <RequiredAstric /></Form.Label>
									<Field name="name" as={commaSeparatedTemplateTypes.includes(type) && !isEdit ? 'textarea' : Form.Control} className="form-control" />
									<div className="text-danger small"><ErrorMessage name="name" /></div>
								</Form.Group>
							</Row>

							<Row className="mb-3">
								<Col>
									<Button type="submit" className='px-3 py-2 me-2' variant="primary" disabled={isSubmitting}>
										{isSubmitting ? t('GENERAL.SAVING') : isEdit ? t('GENERAL.UPDATE') : t('GENERAL.SUBMIT')}
									</Button>
									<Button variant="danger" className='px-3 py-2' onClick={handleClose}>{t('GENERAL.CANCEL')}</Button>
								</Col>
							</Row>
						</Modal.Body>
					</FormikForm>
				)}
			</Formik>
		</Modal >
	);
};

export default TemplateNameModel;
